export const HAN_REGEX = /[\u4e00-\u9fff]/;
